/**
 * Created by Jerker Nord on 2018-08-30.
 */
import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TimelineLite, TimelineMax, TweenLite} from "gsap";
import {IceIceYetiGameModuleConfig} from "../IceIceYetiGameModuleConfig";
import {IceIceYetiReels} from "../reel/reelarea/IceIceYetiReels";
import DisplayObject = PIXI.DisplayObject;
import {IceIceYetiBigWinController} from "../winpresentation/bigwin/IceIceYetiBigWinController";

export class IceIceYetiGameShaker extends BaseController {

    public static readonly START_GAME_SHAKING:string = "iceIceYetiGameShaker_startGameShaking";
    public static readonly STOP_GAME_SHAKING:string = "iceIceYetiGameShaker_stopGameShaking";

    private _mainTL:TimelineMax;
    private _stopped:boolean = true;

    constructor() {
        super();
        this.addEventListeners();
    }

    private addEventListeners():void {
        EventHandler.addEventListener(this, IceIceYetiGameShaker.START_GAME_SHAKING, (event:GameEvent) => this.onStartShakingGame());
        EventHandler.addEventListener(this, IceIceYetiGameShaker.STOP_GAME_SHAKING, (event:GameEvent) => this.onStopShakingGame());
    }

    private createAnimation():void {
        this._mainTL = new TimelineMax({paused : true});
        this._mainTL.add(this.createShakeAnimation(IceIceYetiGameModuleConfig.Background.background, 0.04, 3.4));
        this._mainTL.add(this.createShakeAnimation(IceIceYetiGameModuleConfig.Background.reelBackground, 0.03, 3.4));
        this._mainTL.add(this.createShakeAnimation(IceIceYetiReels.ReelAreaView, 0.02, 3.4));
        this._mainTL.add(this.createShakeAnimation(IceIceYetiGameModuleConfig.ReelIceController.view, 0.02, 3.4));
        this._mainTL.add(this.createShakeAnimation(IceIceYetiGameModuleConfig.Background.foreground, 0.01, 3.4));
        this._mainTL.add(this.createShakeAnimation(IceIceYetiBigWinController._gameView, 0.01, 3.4));
    }

    private onStartShakingGame():void {
        if(!this._mainTL) {
            this.createAnimation();
        }
        this._stopped = false;
        this._mainTL.restart();
    }

    private onStopShakingGame():void {
        this._mainTL.kill();
        this._stopped = true;
    }

    private createShakeAnimation(layer:DisplayObject, frequency:number, maxOffset:number):TimelineLite {
        this._stopped = false;
        if(maxOffset < 0.2) {
            maxOffset = 0.2;
        }
        let animation:TimelineLite = new TimelineLite();
        animation.add(TweenLite.fromTo(layer, frequency,
            {
                x : layer.x + IceIceYetiGameShaker.getShakeOffset(maxOffset),
                y : layer.y + IceIceYetiGameShaker.getShakeOffset(maxOffset),
            },
            {
                x : layer.x,
                y : layer.y,
                onComplete : () => {
                    if(this._stopped) {
                        return;
                    }
                    animation = this.createShakeAnimation(layer, frequency, maxOffset -= 0.2);
                },
                clearProps : "x,y"
            })
        );

        return animation;
    }

    private static getShakeOffset(offset:number):number {
        return Math.floor(Math.random() * (offset + offset + 1) - offset);
    }
}